import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import { authFetch, useAuth } from "../context/AuthContext";

const SIGN_GLYPH = {
    Aries: "♈", Taurus: "♉", Gemini: "♊", Cancer: "♋", Leo: "♌", Virgo: "♍",
    Libra: "♎", Scorpio: "♏", Sagittarius: "♐", Capricorn: "♑", Aquarius: "♒", Pisces: "♓",
};

export default function Compatibility() {
    const { userId } = useParams();
    const { user } = useAuth();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        authFetch("get", `/matches/compatibility/${userId}`)
            .then((r) => setData(r.data))
            .catch(() => setData(null))
            .finally(() => setLoading(false));
    }, [userId]);

    if (loading) {
        return (
            <>
                <Navbar />
                <main className="min-h-screen flex items-center justify-center"><p className="text-muted">Reading the stars between you...</p></main>
            </>
        );
    }
    if (!data) {
        return (
            <>
                <Navbar />
                <main className="min-h-screen flex items-center justify-center"><p className="text-muted">Not found.</p></main>
            </>
        );
    }

    const { compatibility: c, target, ai_reading } = data;

    return (
        <>
            <Navbar />
            <main className="min-h-screen pt-28 pb-12 px-6">
                <div className="max-w-3xl mx-auto space-y-6">
                    <div className="text-center">
                        <p className="label-tracking text-gold">Synastry Reading</p>
                        <h1 className="font-serif text-5xl mt-2">{user?.name} <span className="italic">&</span> {target.name}</h1>
                    </div>

                    {/* Overall Score */}
                    <div className="glass-gold p-10 text-center" data-testid="overall-score-card">
                        <p className="label-tracking text-gold">Overall</p>
                        <p className="font-serif text-7xl text-gold mt-3">{c.overall}</p>
                        <p className="text-muted mt-3 font-serif italic">{c.sun_compat.description}</p>
                    </div>

                    {/* Breakdown */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        <CompatBox label="Sun · Identity" data={c.sun_compat} a={user?.sun} b={target.sun} />
                        <CompatBox label="Moon · Emotion" data={c.moon_compat} a={user?.moon} b={target.moon} />
                        <CompatBox label="Rising · Impression" data={c.rising_compat} a={user?.rising} b={target.rising} />
                    </div>

                    {/* AI Reading */}
                    <div className="glass-gold ai-card p-8">
                        <p className="label-tracking text-gold">AI Synastry · Premium</p>
                        <h2 className="font-serif text-3xl mt-2">A reading written for you both</h2>
                        {ai_reading ? (
                            <p className="font-serif text-lg leading-relaxed mt-4 whitespace-pre-wrap" data-testid="ai-reading-text">
                                {ai_reading}
                            </p>
                        ) : (
                            <div className="mt-4">
                                <p className="text-muted">Unlock the AI synastry reading to discover the deeper cosmic narrative between you two.</p>
                                <Link to="/subscribe" className="btn-gold-solid inline-block mt-6" data-testid="unlock-ai-reading">Unlock Premium</Link>
                            </div>
                        )}
                    </div>
                </div>
            </main>
        </>
    );
}

function CompatBox({ label, data, a, b }) {
    return (
        <div className="glass p-6">
            <p className="label-tracking text-gold">{label}</p>
            <p className="font-serif text-5xl text-center mt-3 text-gold">{data.score}</p>
            <p className="text-center mt-2 text-sm">
                <span>{SIGN_GLYPH[a]} {a}</span>
                <span className="text-muted mx-2">×</span>
                <span>{SIGN_GLYPH[b]} {b}</span>
            </p>
            <p className="text-xs text-muted text-center mt-2 italic">{data.aspect}</p>
        </div>
    );
}
